// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iframe-wrapper iframe[data-v-0ace34f4]{z-index:0;height:800px}@media(min-width:900px){.iframe-wrapper iframe[data-v-0ace34f4]{height:780px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
